module.exports = __webpack_public_path__ + "img/twitter.72e934c4.svg";